export const LINK_COLOR = '#1890FF'
export const BLUE_COLOR = '#3B7DE9'
export const LIGHT_BLUE_COLOR = '#E7F1FD'
export const GREY_BORDER_COLOR = '#D4D8DD'
export const RED_COLOR = '#E31C1C'
export const BLACK_COLOR = '#333'

export const ICON_DEFAULT_COLOR = '#7C8291'
